import React, { useEffect, useState } from 'react';
import styles from './DownloadStatusIndicator.module.scss';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../../../common/components/Spinner';
import ProgressBar from '../../../../components/ProgressBar/ProgressBar';
import { AnimationWrapper } from '../../../../components/AnimationWrapper/AnimationWrapper';
import cx from 'classnames';

const DownloadStatusIndicator = ({ status, percentage }) => {

    const [title, setTitle] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        switch (status) {
            case 'pending':
                setTitle('');
                break;

            case 'processing':
                setTitle(t('download_modal.processing_title'));
                break;

            case 'downloading':
                setTitle(t('download_modal.downloading'));
                break;

            default:
                setTitle('');
                break;
        }

        return () => setTitle('');
    }, [status, t]);

    return (
        status !== 'pending' ? <>
            <div className={cx(styles.titleContainer, styles.noPostInfo)}>
                <AnimationWrapper show={title !== ''}>
                    <h1 className={styles.title}>{title}</h1>
                </AnimationWrapper>
                <AnimationWrapper show={percentage >= 99 && status === 'processing'} from={{ opacity: 0 }}
                    to={{ opacity: 1 }} options={{ duration: 250 }}>
                    <Spinner width="30px" height="30px" size="3px" className={styles.spinner} />
                </AnimationWrapper>
            </div >
            <AnimationWrapper show={status === 'processing' && percentage < 99} from={{ opacity: 0 }}
                to={{ opacity: 1 }} options={{ duration: 250 }}>
                <ProgressBar percentage={percentage} readyMsg={t('download_modal.ready_for_download')} />
            </AnimationWrapper>
            <AnimationWrapper show={status === 'downloading'} from={{ opacity: 0 }}
                to={{ opacity: 1 }} options={{ duration: 250 }}>
                <ProgressBar percentage={percentage} readyMsg={t('download_modal.ready_for_download')} />
            </AnimationWrapper>
        </> : null);
}

export default DownloadStatusIndicator;